const nexgardProducts = [
{
    image: '/pet_images/NG_Spectra_XS_Single.jpg',
    id: 'NG_Spectra_XS_Single',
    name: 'NexGard Spectra XS Single (2-3.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 124,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'small',
    sterilised: 'No',
    productSize: '2-3.5kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '2-3.5kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070274',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'small',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0009',
      colour: 'Orange'
    },
  },
{
    image: '/pet_images/NG_Spectra_XS_3Pack.jpg',
    id: 'NG_Spectra_XS_3Pack',
    name: 'NexGard Spectra XS 3 Pack (2-3.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 351.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'small',
    sterilised: 'No',
    productSize: '2-3.5kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '2-3.5kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070434',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'small',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0055',
      colour: 'Orange'
    },
  },
{
    image: '/pet_images/NG_Spectra_S_Single.jpg',
    id: 'NG_Spectra_S_Single',
    name: 'NexGard Spectra S Single (3.5-7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 135.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'small',
    sterilised: 'No',
    productSize: '3.5-7.5kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '3.5-7.5kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070281',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'small',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0010',
      colour: 'Yellow'
    },
  },
{
    image: '/pet_images/NG_Spectra_S_3Pack.jpg',
    id: 'NG_Spectra_S_3Pack',
    name: 'NexGard Spectra S 3 Pack (3.5-7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 383.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'small',
    sterilised: 'No',
    productSize: '3.5-7.5kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '3.5-7.5kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070441',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'small',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0056',
      colour: 'Yellow'
    },
  },
{
    image: '/pet_images/NG_Spectra_M_Single.jpg',
    id: 'NG_Spectra_M_Single',
    name: 'NexGard Spectra M Single (7.5-15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 207.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'medium',
    sterilised: 'No',
    productSize: '7.5-15kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '7.5-15kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070298',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0011',
      colour: 'Green'
    },
  },
{
    image: '/pet_images/NG_Spectra_M_3Pack.jpg',
    id: 'NG_Spectra_M_3Pack',
    name: 'NexGard Spectra M 3 Pack (7.5-15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 591.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'medium',
    sterilised: 'No',
    productSize: '7.5-15kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '7.5-15kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070458',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0057',
      colour: 'Green'
    },
  },
{
    image: '/pet_images/NG_Spectra_L_Single.jpg',
    id: 'NG_Spectra_L_Single',
    name: 'NexGard Spectra L Single (15-30kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 255.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'large',
    sterilised: 'No',
    productSize: '15-30kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '15-30kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070304',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'large',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0012',
      colour: 'Purple'
    },
  },
{
    image: '/pet_images/NG_Spectra_L_3Pack.jpg',
    id: 'NG_Spectra_L_3Pack',
    name: 'NexGard Spectra L 3 Pack (15-30kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 727.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'large',
    sterilised: 'No',
    productSize: '15-30kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '15-30kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070465',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'large',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0058',
      colour: 'Purple'
    },
  },
{
    image: '/pet_images/NG_Spectra_XL_Single.jpg',
    id: 'NG_Spectra_XL_Single',
    name: 'NexGard Spectra XL Single (30-60kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 319.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'giant',
    sterilised: 'No',
    productSize: '30-60kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '30-60kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070311',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'giant',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0013',
      colour: 'Red'
    },
  },
{
    image: '/pet_images/NG_Spectra_XL_3Pack.jpg',
    id: 'NG_Spectra_XL_3Pack',
    name: 'NexGard Spectra XL 3 Pack (30-60kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 911.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'giant',
    sterilised: 'No',
    productSize: '30-60kg',
    description: 'NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms. Monthly protection from the makers of FRONTLINE.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard Spectra for dogs is a highly palatable beef-flavoured chew that kills fleas and ticks, prevents heartworm disease and treats intestinal worms (roundworm, hookworm, whipworm and lungworm) in dogs and puppies.<br><br>Indications: Antiparasitic for canine internal and external parasites<br><br>Active: Afoxolaner, milbemycin oxime - Read more <a href="https://www.absolutepets.com/clients/absolutepets/downloads/nexgardspectra_flashcard.pdf" target="_blank" rel="noopener">here</a></p> </div><div id="tab-2" class="tab-pane"><p>afoxolaner, milbemycin oxime</p> </div></div>',
    keyBenefits: ['Flea & tick protection:', 'Heartworm prevention:', 'Intestinal worm treatment:', 'Beef-flavoured chew:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '30-60kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: '6009706070472',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick, Flea & Deworming',
      breed: 'No',
      breed_size: 'giant',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0059',
      colour: 'Red'
    },
  },
{
    image: '/pet_images/NG_Chew_S_Single.jpg',
    id: 'NG_Chew_S_Single',
    name: 'NexGard Chewables S Single (2-4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 108,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'small',
    sterilised: 'No',
    productSize: '2-4kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '2-4kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300ORANG001',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'small',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0073S',
      colour: 'Orange'
    },
  },
{
    image: '/pet_images/NG_Chew_S_3Pack.jpg',
    id: 'NG_Chew_S_3Pack',
    name: 'NexGard Chewables S 3 Pack (2-4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 308,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'small',
    sterilised: 'No',
    productSize: '2-4kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '2-4kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300ORANG002',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'small',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0077S',
      colour: 'Orange'
    },
  },
{
    image: '/pet_images/NG_Chew_M_Single.jpg',
    id: 'NG_Chew_M_Single',
    name: 'NexGard Chewables M Single (4-10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 108,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'medium',
    sterilised: 'No',
    productSize: '4-10kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '4-10kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300BLUE002',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0074S',
      colour: 'Blue'
    },
  },
{
    image: '/pet_images/NG_Chew_M_3Pack.jpg',
    id: 'NG_Chew_M_3Pack',
    name: 'NexGard Chewables M 3 Pack (4-10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 308,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'medium',
    sterilised: 'No',
    productSize: '4-10kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '4-10kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300BLUE003',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0078S',
      colour: 'Blue'
    },
  },
{
    image: '/pet_images/NG_Chew_L_Single.jpg',
    id: 'NG_Chew_L_Single',
    name: 'NexGard Chewables L Single (10-25kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 135.2,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'large',
    sterilised: 'No',
    productSize: '10-25kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '10-25kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300PURP004',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'large',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0075S',
      colour: 'Purple'
    },
  },
{
    image: '/pet_images/NG_Chew_L_3Pack.jpg',
    id: 'NG_Chew_L_3Pack',
    name: 'NexGard Chewables L 3 Pack (10-25kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 388,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'large',
    sterilised: 'No',
    productSize: '10-25kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '10-25kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300PURP005',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'large',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0079S',
      colour: 'Purple'
    },
  },
{
    image: '/pet_images/NG_Chew_XL_Single.jpg',
    id: 'NG_Chew_XL_Single',
    name: 'NexGard Chewables XL Single (25-50kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1,
    price: 167.2,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'giant',
    sterilised: 'No',
    productSize: '25-50kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '25-50kg', idealWeight: 'Single', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300RED006',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'giant',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0076S',
      colour: 'Red'
    },
  },
{
    image: '/pet_images/NG_Chew_XL_3Pack.jpg',
    id: 'NG_Chew_XL_3Pack',
    name: 'NexGard Chewables XL 3 Pack (25-50kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3,
    price: 476,
    category: 'Tick & Flea',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'giant',
    sterilised: 'No',
    productSize: '25-50kg',
    description: 'NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard soft beef-flavoured chews kill fleas and ticks for 30 days. From the makers of FRONTLINE Plus, the palatable chew is safe and effective for monthly protection.ffective for a full 30 days.<br><br>NexGard for dogs kills adult fleas before they lay eggs, and kills ticks, too. All in a delicious, soft chew that dogs love.<br><br>NexGard is for use in dogs only. The most frequently reported adverse reactions include vomiting, dry/flaky skin, diarrhea, lethargy, and lack of appetite. The safe use of NexGard in pregnant, breeding or lactating dogs has not been evaluated. Use with caution in dogs with a history of seizures.</p> </div></div>',
    keyBenefits: ['Kills fleas & ticks:', 'Beef-flavoured chew:', 'Monthly protection:'],
    feedingGuide: [{weight: 'PET WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '25-50kg', idealWeight: '3 Pack', overweight: 'Once monthly'}],
    additionalInfo: {
      barcode: 'NEX0300RED007',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Healthcare',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'giant',
      flavour: 'Beef',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0080S',
      colour: 'Red'
    },
  },
{
    image: '/pet_images/NG_Combo_LT2_5kg.jpg',
    id: 'NG_Combo_LT2_5kg',
    name: 'NexGard Combo (<2.5kg) (0.3ml)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.3,
    price: 151.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'small',
    sterilised: 'No',
    productSize: '<2.5kg',
    description: 'NexGard Combo for cats provides broad-spectrum protection against fleas, ticks, mites, heartworm, roundworm, hookworm and tapeworm. Topical spot-on safe for kittens 8 weeks+.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard COMBO is indicated for the prevention of heartworm disease and for the treatment and control of roundworm, hookworm and tapeworm infections.<br><br>NexGard Combo kills adult fleas and is indicated for the treatment and prevention of flea infestations and the treatment and treatment control of tick infestations for one month in cats.<br><br>NexGard COMBO may be used in cats and kittens as young as 8 weeks and weighing 0.8kg or greater.<br><br>NexGard COMBO is safe for pregnant, lactating and breeding cats.<br><br>NexGard COMBO, new broad-spectrum parasite protection specifically formulated for feline patients.</p> </div><div id="tab-2" class="tab-pane"><p>Esafoxolaner: 12 mg <br>Eprinomectin: 4 mg <br>Praziquantel: 83 mg</p> </div><div id="tab-3" class="tab-pane"><p></p><ol><br><li>Use scissors to cut the blister along the dotted line.</li><br><li>Then pull the lid away. </li><br><li>Remove the applicator from the package and hold it upright. Pull back the plunger slightly.</li><br><li>Twist and pull of the cap. </li><br><li>Part the hair on the midline of the neck, between the base of the skull and the shoulder blades until the skin is visible. Place the tip of the applicator on the skin and apply the entire contents directly onto the skin in one spot. The product should be applied to dry skin on an arear where the cat cannot lick it off. If the weight of the cat requires a second application, apply the contents in the same manner as described above in the same location.</li><br><li>Wash hands afer use with soap and water. WARNING Not for human use. Keep this and all drugs out of sight and reach of children. Avoid direct contact with application site for 4 hours or until visibly dry. This product may act as a mild to moderate eye irritant.</li><br></ol> </div><div id="tab-4" class="tab-pane"><p>Cat (weighing less than 2.5kg): 1 Applicator</p> </div><div id="tab-5" class="tab-pane"><p></p><ul><br><li>Features the first isoxaline - esafoxolaner which was formulated specifically to protect feline patients</li><br><li>NexGard COMBO topical solution is the only broad-spectrum protection for felines that covers fleas, ticks, mites, roundworks, hookworms, lungworms, heartworm disease and tapeworms.</li><br><li>Safe for use in kittens as young as 8 weeks, 0.8 kg or more</li><br></ul> </div></div>',
    keyBenefits: ['Broad-spectrum protection:', 'Flea & tick control:', 'Heartworm prevention:', 'Safe for kittens 8+ weeks:'],
    feedingGuide: [{weight: 'CAT WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '<2.5kg', idealWeight: '1 Applicator (0.3ml)', overweight: 'Monthly'}],
    additionalInfo: {
      barcode: '4064951003028',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Spot-on',
      product_feature: 'Flea, Tick & Worm',
      breed: 'No',
      breed_size: 'small',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0049',
      colour: 'Purple'
    },
  },
{
    image: '/pet_images/NG_Combo_2_5_7_5kg.jpg',
    id: 'NG_Combo_2_5_7_5kg',
    name: 'NexGard Combo (2.5-7.5kg) (0.9ml)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.9,
    price: 167.2,
    category: 'Tick, Flea & Deworming',
    brand: 'NexGard',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'medium',
    sterilised: 'No',
    productSize: '2.5-7.5kg',
    description: 'NexGard Combo for cats provides broad-spectrum protection against fleas, ticks, mites, heartworm, roundworm, hookworm and tapeworm. Topical spot-on safe for kittens 8 weeks+.',
    longDescription: '<div class="std" itemprop="description"><div id="tab-1" class="tab-pane active"> <p>NexGard COMBO is indicated for the prevention of heartworm disease and for the treatment and control of roundworm, hookworm and tapeworm infections.<br><br>NexGard Combo kills adult fleas and is indicated for the treatment and prevention of flea infestations and the treatment and treatment control of tick infestations for one month in cats.<br><br>NexGard COMBO may be used in cats and kittens as young as 8 weeks and weighing 0.8kg or greater.<br><br>NexGard COMBO is safe for pregnant, lactating and breeding cats.<br><br>NexGard COMBO, new broad-spectrum parasite protection specifically formulated for feline patients.</p> </div><div id="tab-2" class="tab-pane"><p></p><ul><br><li>Features the first isoxaline - esafoxolaner which was formulated specifically to protect feline patients</li><br><li>NexGard COMBO topical solution is the only broad-spectrum protection for felines that covers fleas, ticks, mites, roundworks, hookworms, lungworms, heartworm disease and tapeworms.</li><br><li>Safe for use in kittens as young as 8 weeks, 0.8 kg or more</li><br></ul> </div><div id="tab-3" class="tab-pane"><p>Esafoxolaner: 12 mg <br>Eprinomectin: 4 mg <br>Praziquantel: 83 mg</p> </div><div id="tab-4" class="tab-pane"><p></p><ol><br><li>Use scissors to cut the blister along the dotted line.</li><br><li>Then pull the lid away. </li><br><li>Remove the applicator from the package and hold it upright. Pull back the plunger slightly.</li><br><li>Twist and pull of the cap. </li><br><li>Part the hair on the midline of the neck, between the base of the skull and the shoulder blades until the skin is visible. Place the tip of the applicator on the skin and apply the entire contents directly onto the skin in one spot. The product should be applied to dry skin on an arear where the cat cannot lick it off. If the weight of the cat requires a second application, apply the contents in the same manner as described above in the same location.</li><br><li>Wash hands afer use with soap and water. WARNING Not for human use. Keep this and all drugs out of sight and reach of children. Avoid direct contact with application site for 4 hours or until visibly dry. This product may act as a mild to moderate eye irritant.</li><br></ol> </div><div id="tab-5" class="tab-pane"><p>Cat (weighing between 2.5kg and up to 7.5 kg): 1 Applicator 0,9 mL</p> </div></div>',
    keyBenefits: ['Features the first isoxaline - esafoxolaner which was formulated specifically to protect feline patients', 'NexGard COMBO topical solution is the only broad-spectrum protection for felines that covers fleas, ticks, mites, roundworks, hookworms, lungworms, heartworm disease and tapeworms.', 'Safe for use in kittens as young as 8 weeks, 0.8 kg or more'],
    feedingGuide: [{weight: 'CAT WEIGHT', idealWeight: 'DOSE', overweight: 'FREQUENCY'}, {weight: '2.5-7.5kg', idealWeight: '1 Applicator (0.9ml)', overweight: 'Monthly'}],
    additionalInfo: {
      barcode: '350604000747',
      brands: 'NexGard',
      brand: 'NexGard',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Spot-on',
      product_feature: 'Flea, Tick & Worm',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'M17-0050',
      colour: 'Yellow'
    },
  },

];

export { nexgardProducts };
export default nexgardProducts;
